import { useRecoilValue } from "recoil"
import { applicationSummariesState, hasFetchedInitialApplications } from "state"
import { ApplicationSummaryEnhanced } from "models/ApplicationSummaryEnhanced"

interface Args {
  applicationData?: { applicationId: string } | null
  friendlyId?: string
}

export function useApplicationSummaryEnhanced({ applicationData, friendlyId }: Args): {
  application: ApplicationSummaryEnhanced | null
  hasLoaded: boolean
} {
  const applicationSummaries = useRecoilValue(applicationSummariesState)
  const hasFetchedSummaries = useRecoilValue(hasFetchedInitialApplications)

  const applicationId = applicationData?.applicationId

  const application =
    (applicationId
      ? applicationSummaries.find((app) => app.applicationId === applicationId)
      : friendlyId
      ? applicationSummaries.find((app) => app.friendlyId === friendlyId)
      : null) || null

  return {
    application,
    hasLoaded: hasFetchedSummaries,
  }
}
